import { PublicSession } from "@classview/shared-types";

export function getOrgSessionStatus({
  orgId,
  session,
}: {
  orgId: string;
  session: PublicSession;
}) {
  const orgSession = session.invitedOrganisations.find(
    (org) => org.id === orgId,
  );
  if (!orgSession) return null;

  return orgSession.status;
}
